// src/components/PrescriptionCard.tsx
import React from "react";
import QuestionnaireResponseCard from "./QuestionnaireResponseCard";
import ProviderNotesCard from "./ProviderNotesCard";
import { Prescription } from "../types/prescription";
import { PatientProfile } from "../types/user";
import "../styles/prescriptions/prescriptionCard.css";

interface Props {
  prescription: Prescription;
}

const PrescriptionCard: React.FC<Props> = ({ prescription }) => {
  const { patient, medication, questionnaireResponse } = prescription;

  const profile = patient.patientProfile as PatientProfile & {
    userId?: string;
  };
  const entry = prescription.prescriberEntry ?? {
    dosage: "",
    quantity: 0,
    refills: 0,
    instructions: "",
  };

  const age = profile.dob
    ? Math.floor(
        (Date.now() - new Date(profile.dob).getTime()) /
          (1000 * 60 * 60 * 24 * 365.25)
      )
    : "N/A";

  return (
    <div className="prescription-card">
      <div className="prescription-patient-info">
        <div className="prescription-patient-info-card">
          <h4>Status: {prescription.status}</h4>

          <p>
            <strong>Patient:</strong> {profile.firstName} {profile.lastName}
          </p>
          <p>
            <strong>Age:</strong> {age}
          </p>
          <p>
            <strong>Gender:</strong> {profile.gender}
          </p>
          <p>
            <strong>Medication:</strong> {medication.name} ({medication.type})
          </p>
          <p>
            <strong>Quantity:</strong> {entry.quantity}
          </p>
          <p>
            <strong>Instructions:</strong> {entry.instructions}
          </p>
          <p>
            <strong>Refills:</strong> {entry.refills}
          </p>
        </div>

        <ProviderNotesCard
          initialNotes={profile.providerNotes || []}
          patientProfileId={profile.id}
          onSave={(note) => console.log("Provider note saved:", note)}
        />
      </div>

      <QuestionnaireResponseCard response={questionnaireResponse as any} />
    </div>
  );
};

export default PrescriptionCard;
